import {useState} from 'react'
import type {RlStandardSetT} from '@freckle/educator-entities/ts/common/models/rl-standard-set'
import type {RlDomainIdT} from '@freckle/educator-entities/ts/common/types/rl-domain-id'
import type {BaseTeacherAttrs} from '@freckle/educator-entities/ts/users/models/teacher'
import type {ButtonStyleT} from '@freckle/educator-materials/ts/components/button'
import {Button} from '@freckle/educator-materials/ts/components/button'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {ProficiencyReportStudentBucket as StudentBucket} from '@freckle/school/ts/proficiency-report/components/student-bucket'
import {StudentCategories} from '@freckle/school/ts/proficiency-report/logic/proficiency-report-table-logic'
import type {ProficiencyReportTableRowT} from '@freckle/school/ts/proficiency-report/logic/proficiency-report-table-logic'
import type {StudentsMapT} from '@freckle/school/ts/users/collections/students'
import TeacherTable from './teacher-table'

type Props = {
  students: StudentsMapT
  teachers: Array<BaseTeacherAttrs>
  tableRow: ProficiencyReportTableRowT
  selectedGrade: number
  selectedDomainId: RlDomainIdT
  mathStandardSet: RlStandardSetT
}

export function ProficiencyReportExpandableRow(props: Props) {
  const {students, teachers, tableRow, selectedGrade, selectedDomainId, mathStandardSet} = props
  const {t} = useSafeTranslation()

  const [isShowingStudentView, setIsShowingStudentView] = useState<boolean>(true)

  const buckets = StudentCategories.all().map(category => (
    <StudentBucket
      key={`student-bucket-${category}-${tableRow.schoolId}`}
      students={students}
      bucketData={tableRow}
      category={category}
      mathStandardSet={mathStandardSet}
    />
  ))

  const [studentBtnStyle, teacherBtnStyle] = isShowingStudentView
    ? ['primary', 'secondary']
    : ['secondary', 'primary']

  return (
    <div className="proficiency-report-expandable-row">
      <div role="group">
        <Button
          className="toggle-btn"
          onClick={() => {
            setIsShowingStudentView(true)
          }}
          style={studentBtnStyle as ButtonStyleT}
        >
          {t('PROFICIENCY_REPORT_EXPANDABLE_ROW_BUTTON_VIEW_STUDENTS')}
        </Button>
        <Button
          className="toggle-btn"
          onClick={() => {
            setIsShowingStudentView(false)
          }}
          style={teacherBtnStyle as ButtonStyleT}
        >
          {t('PROFICIENCY_REPORT_EXPANDABLE_ROW_BUTTON_VIEW_TEACHERS')}
        </Button>
      </div>
      {isShowingStudentView ? (
        <div key="student-buckets" className="proficiency-report-student-buckets-wrapper row">
          {buckets}
        </div>
      ) : null}
      {!isShowingStudentView ? (
        <TeacherTable
          key="teacher-table"
          tableRow={tableRow}
          teachers={teachers}
          selectedGrade={selectedGrade}
          selectedDomainId={selectedDomainId}
        />
      ) : null}
    </div>
  )
}
